<template>
  <div id="android">
      <mycarousel></mycarousel>
      <div class="android1 titleBox">
        <p class="title">专业安卓APP开发，让您不费吹灰之力</p>
        <ul>
            <li v-for="(item,index) in android1" :key="index" class="wow animate__animated animate__fadeInUp">
              <img :src="item.icon" alt="">
              <p class="android1Title">{{item.title}}</p>
              <p class="android1Subtitle">{{item.subtitle}}</p>
            </li>
          </ul>
      </div>
      <div class="android2 titleBox"> 
        <p class="title">四大服务保障，保证您的权益</p>
        <ul>
          <li v-for="(item,index) in android2" :key="index" @mouseover="changeAndroid2Index=index" class="wow animate__animated animate__fadeInLeft">
              <img :src="item.icon" alt="">
              <div>
                  <p class="p1">{{item.title}}</p>
                  <p class="p2" v-show="changeAndroid2Index==index">{{item.subtitle}}</p>
              </div>
          </li>
        </ul>
      </div>
      <div class="android3 titleBox">
        <p class="title">六大服务流程，全程为您保驾护航</p>
        <p class="subtitle">十年开发定制服务经验，更专业，更优质</p>
        <img src="../../assets/android/android3Bg.png" alt="" class="bg">
        <ul>
          <li v-for="(item,index) in android3" :key="index" class="wow animate__animated animate__fadeInUp">
              <div>
                  <p class="p1"><img :src="item.icon" alt="">{{item.title}}</p>
                  <p class="p2">{{item.subtitle}}</p>
              </div>
          </li>
        </ul>
      </div>
      <div class="android4 titleBox">
        <p class="title">专业团队让您买的放心</p>
        <p class="subtitle">十年开发定制服务经验，更专业，更优质</p>
        <ul>
          <li v-for="(item,index) in android4" :key="index"  class="wow animate__animated animate__fadeInLeft">
            <p class="p1">{{item.title}}</p>
            <p class="p2">{{item.subtitle}}</p>
            <img :src="item.icon" alt="">
            <button>查看更多</button>
          </li>
        </ul>
      </div>

      <div class="android5 titleBox">
        <p class="title">四大服务保障，保证您的权益</p>
        <ul>
          <li v-for="(item,index) in android5" :key="index" class="wow animate__animated animate__fadeInUp">
            <img :src="item.bg" alt="" class="bg">
            <div>
              <img :src="item.icon" alt="">
              <p>{{item.title}}</p>
            </div>
          </li>
        </ul>
        <img src="@/assets/android/android5Button.png" alt="" class="button">
      </div>
      <mytechnology></mytechnology>
  </div>
</template>

<script>
import mycarousel from  '@/components/carousel/carousel.vue'
import mytechnology from  '@/components/technology/technology.vue'
export default {
  name: "android",
  components: {
    mycarousel,
    mytechnology
  },
  data(){
    return {
      android1:[
        {
            icon:require('@/assets/android/android1icon1.png'),
            title:"量身定制 多行业覆盖",
            subtitle:"满足多个行业广泛业务需求，提升企业品牌化发展，量身定制"
        },
        {
            icon:require('@/assets/android/android1icon2.png'),
            title:"专业技术团队",
            subtitle:"从商业模式优化、产品模型、技术方案落地实施快速形成行业平台解决方案"
        },
        {
            icon:require('@/assets/android/android1icon3.png'),
            title:"产品级研发",
            subtitle:"助力idea落地、注重用户体验、可拓展、快速迭代，以产品级标准输出"
        },
        {
            icon:require('@/assets/android/android1icon4.png'),
            title:"高并发数据处理",
            subtitle:"大数据处理能力、缓存机制、数据库集群、CDN负载均衡"
        }
      ],
      changeAndroid2Index:0,
      android2:[
        {
            icon:require('@/assets/android/android2icon1.png'),
            title:"服务保障",
            subtitle:"售前、售中、售后全方位保障"
        },
        {
            icon:require('@/assets/android/android2icon2.png'),
            title:"技术保障",
            subtitle:"售前、售中、售后全方位保障"
        },
        {
            icon:require('@/assets/android/android2icon3.png'),
            title:"专业保障",
            subtitle:"售前、售中、售后全方位保障"
        },
        {
            icon:require('@/assets/android/android2icon4.png'),
            title:"交付保障",
            subtitle:"售前、售中、售后全方位保障"
        }
      ],
      android3:[
        {
            icon:require('@/assets/android/android3icon1.png'),
            title:"市场中心",
            subtitle:"商务沟通/需求调研/业务架构设计/可行性分析"
        },
        {
            icon:require('@/assets/android/android3icon2.png'),
            title:"系统架构",
            subtitle:"难点攻关/架构设计/接口设计/数据库设计/框架搭建/技术文档编写"
        },
        {
            icon:require('@/assets/android/android3icon3.png'),
            title:"项目管控",
            subtitle:"商务沟通/需求调研/业务架构"
        },
        {
            icon:require('@/assets/android/android3icon4.png'),
            title:"研发中心",
            subtitle:"制定开发/管控进度/系统编码"
        },
        {
            icon:require('@/assets/android/android3icon5.png'),
            title:"产品设计中心",
            subtitle:"客户沟通/原型设计/UI设计/产品需求文档编写"
        },
        {
            icon:require('@/assets/android/android3icon6.png'),
            title:"质检中心",
            subtitle:"测试用例编写/测试执行/测试报告编写/测试项目沟通"
        }
      ],
      android4:[
        {
            icon:require('@/assets/android/android4icon1.png'),
            title:"技术团队",
            subtitle:"核心技术团队均来自大型互联网企业，为各行业领先企业提供了大量技术研发"
        },
        {
            icon:require('@/assets/android/android4icon2.png'),
            title:"技术框架",
            subtitle:"采用SpringCloud、Dubbo等微服务框架，内建微服务治理能力"
        },
        {
            icon:require('@/assets/android/android4icon3.png'),
            title:"技术研发",
            subtitle:"基于系统级软件平台研发的流程管理，可实现开发、测试、发布、运维、运营"
        }
      ],
      android5:[
        {
            icon:require('@/assets/android/android5icon1.png'),
            title:"互联网科技",
            bg:require('@/assets/android/android5bg1.png')
        },
        {
            icon:require('@/assets/android/android5icon2.png'),
            title:"广告传媒",
            bg:require('@/assets/android/android5bg2.png')
        },
        {
            icon:require('@/assets/android/android5icon3.png'),
            title:"商业服务",
            bg:require('@/assets/android/android5bg3.png')
        },
        {
            icon:require('@/assets/android/android5icon4.png'),
            title:"教育培训",
            bg:require('@/assets/android/android5bg4.png')
        },
        {
            icon:require('@/assets/android/android5icon5.png'),
            title:"食品生鲜",
            bg:require('@/assets/android/android5bg5.png')
        },
        {
            icon:require('@/assets/android/android5icon6.png'),
            title:"更多行业",
            bg:require('@/assets/android/android5bg6.png')
        }
      ]
    }
  }
}
</script>

<style lang="scss">
  :root {
    --web-max-width: 1920px;
    --web-min-width: 1300px;
  } 
  .titleBox{
    .title{
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      padding-top: 60px;
      text-align: center;
      margin-bottom: 12px;
    }
    .subtitle{
      font-size: 16px;
      font-weight: 400;
      color: #A2A5AC;
      text-align: center;
      margin-bottom: 60px;
    }
  }
  #android{
    min-width:var(--web-min-width);
    margin:0 auto;
    .android1{
        img{
            width: 190px;
        }
        ul{
            width: 1200px;
            margin:60px auto 0;
            display: flex;
            li{
                width: 286px;
                background: #F8F9FC;
                border-radius: 8px 8px 8px 8px;
                text-align: center;
                padding:26px 20px 18px;
                .android1Title{
                    font-size: 24px;
                    font-weight: 400;
                    color: #333333;
                    margin-top: 16px;
                }
                .android1Subtitle{
                    font-size: 14px;
                    font-weight: 400;
                    color: #A2A5AC;
                    margin-top: 12px;
                    line-height: 1.8;
                }
            }
            li:nth-child(-n+3){
                margin-right: 19px;
            }
        }
    }
    .android2{
      position: relative;
      min-width:var(--web-min-width);
      margin:64px auto 0;
      height: 620px;
      background-image: url("../../assets/android/android2Bg.png");
      background-size: cover ;
      background-repeat: no-repeat;
      ul{
        width: 1200px;
        margin:0 auto;
        li{
          width: 304px;
          height: 96px;
          background: #FFFFFF;
          box-shadow: 0px 2px 18px 1px rgba(217,223,231,0.6);
          border-radius: 8px 8px 8px 8px;
          display: flex;
          align-items: center;
          padding-left: 30px;
          img{
            width: 60px;
            height: 60px;
            margin-right: 16px;
          }
          .p1{
            font-size: 16px;
            font-weight: 400;
            color: #333333;
          }
          .p2{
            font-size: 14px;
            font-weight: 400;
            color: #A2A5AC;
          }
        }
        li:nth-child(-n+3){
          margin-bottom: 26px;
        }
      }
    }
    .android3{
      position: relative;
      padding-bottom: 80px;
      .bg{
        width: 560px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: -1;
      }
      ul{
        width: 1200px;
        margin:0 auto;
        display: flex;
        flex-wrap: wrap;
        li{
          flex:0 0 25%;
          div{
            width: 210px;
            height: 118px;
            background: #FFFFFF;
            box-shadow: 0px 2px 18px 1px rgba(152,152,152,0.1);
            border-radius: 4px 4px 4px 4px;
            padding: 24px 16px;
            .p1{
              font-size: 20px;
              font-weight: 500;
              color: #333333;
              display: flex;
              align-items: center;
              margin-bottom: 9px;
            }
            .p2{
              font-size: 14px;
              font-weight: 400;
              color: #666666;
            }
            img{
              width: 22px;
              margin-right: 8px;
            }
          }
        }
        li:nth-child(2n+1){
          flex:0 0 74%;
        }
        li:nth-child(-n+4) div{
          margin-bottom: 40px;
        }
        li:nth-child(1) div{
          margin-left: 105px;
        }
        li:nth-child(2) div{
          width: 257px;
        }
        li:nth-child(4) div{
          margin-left: 96px;
        }
        li:nth-child(5) div{
          width: 260px;
          margin-left: 56px;
        }
        li:nth-child(6) div{
          width: 260px;
        }
      }
    }

    .android4{
      background-color: #F8F9FC;
      padding-bottom: 78px;
      ul{
        width: 1200px;
        margin:0 auto;
        display: flex;
        li{
          width: 368px;
          height: 450px;
          background: #FFFFFF;
          border-radius: 8px 8px 8px 8px;
          padding: 34px;
          text-align: center;
          .p1{
            font-size: 18px;
            font-weight: 500;
            color: #333333;
            margin-bottom: 16px;
          }
          .p2{
            font-size: 16px;
            font-weight: 400;
            color: #999999;
            margin-bottom: 40px;
          }
          img{
            width: 200px;
          }
          button{
            display: block;
            width: 120px;
            height: 40px;
            background: #EEF6FF;
            border-radius: 100px 100px 100px 100px;
            margin:50px auto 0;
            font-size: 18px;
            font-weight: 400;
            color: #3B8DFF;
          }
        }
        li:nth-child(-n+2){
          margin-right: 48px;
        }
      }
    }

    .android5{
      ul{
        width: 1200px;
        margin:46px auto;
        display: flex;
        flex-wrap: wrap;
        li{
          width: 380px;
          height: 200px;
          background: #161E30;
          border-radius: 8px 8px 8px 8px;
          position: relative;
          .bg{
            width: 100%;
            overflow: hidden;
          }
          div{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            text-align: center;
            img{
              width: 32px;
            }
            p{
              margin-top: 4px;
              font-size: 16px;
              font-weight: 400;
              color: #FFFFFF;
            }
          }
        }
        li:nth-child(-n+3){
          margin-bottom: 30px;
        }
        li:nth-child(-n+2){
          margin-right: 30px;
        }
        li:nth-child(n+4):nth-child(-n+5){
          margin-right: 30px;
        }
      }
      .button{
        width: 306px;
        display: block;
        margin:0 auto;
        cursor: pointer;
      }
    }
  }
</style>